<template>
    <div>
        <div v-if="!editing" class="level is-mobile">
            <div class="level-left is-shrinkable">
                <div class="level-item is-shrinkable">
                    <app-collapsable-text :text="highlightedText" />
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <div
                        v-if="hasAdminPermission || editable"
                        :class="{
                            'is-active': showDropdown,
                            'is-up': !dropdown,
                        }"
                        class="dropdown is-right is-pulled-right mr-1"
                    >
                        <div
                            ref="toggleButton"
                            class="dropdown-trigger has-cursor-pointer"
                            @click.prevent.stop="toggleDropdown"
                        >
                            <span class="icon is-small has-text-grey">
                                <i
                                    class="mdi mdi-24px mdi-dots-vertical"
                                    aria-hidden="true"
                                />
                            </span>
                        </div>
                        <div
                            id="dropdown-menu"
                            v-on-clickaway.self="hideDropdown"
                            class="dropdown-menu"
                            role="menu"
                        >
                            <div class="dropdown-content">
                                <a
                                    v-if="editable && !editionDisabled"
                                    v-t="'Buttons.edit'"
                                    class="dropdown-item"
                                    @click.stop="startEditing"
                                />
                                <a
                                    v-t="'Buttons.delete'"
                                    class="dropdown-item"
                                    @click="$emit('delete')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-message-input-bar
            v-else
            v-on-clickaway="disableEditing"
            :pre-message="message"
            :show-cancel="true"
            :has-editor="hasEditor"
            @comment="emitEdit"
            @cancel="editing = false"
        />
    </div>
</template>

<script>
import AppCollapsableText from '@/components/AppCollapsableText';
import AppMessageInputBar from '@/components/AppMessageInputBar';
import { mixin as clickaway } from '@/directives/vue-clickaway';
export default {
    components: {
        AppCollapsableText,
        AppMessageInputBar,
    },
    mixins: [clickaway],
    props: {
        message: {
            type: String,
            default: '',
        },
        editable: {
            type: Boolean,
            default: false,
        },
        dropdown: {
            type: Boolean,
            default: false,
        },
        hasEditor: {
            type: Boolean,
            default: false,
        },
        editionDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            editing: false,
            showDropdown: false,
        };
    },
    computed: {
        highlightedText() {
            return this.message.replace(
                /\B@\w+/g,
                "<a class='tag is-primary is-light is-size-6'>$&</a>"
            );
        },
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
    },
    methods: {
        hideDropdown(event) {
            if (this.$refs.toggleButton.contains(event.target)) {
                return;
            }
            this.showDropdown = false;
            this.editing = false;
        },
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        startEditing() {
            this.editing = true;
            this.showDropdown = false;
            this.$emit('startEdit');
        },
        disableEditing() {
            this.editing = false;
            this.showDropdown = false;
        },
        emitEdit(message) {
            this.$emit('edit', message);
            this.editing = false;
            this.showDropdown = false;
        },
    },
};
</script>

<style></style>
